
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-globe" })
export default class IconGlobe extends Vue {
  sData: string = require("@icon/feather/globe.svg");
}
